import styled, { css } from 'styled-components'

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const LineItemWrapper = styled.div`
  ${props =>
    props.cancelled &&
    css`
      text-decoration: line-through;
      opacity: 0.6;
    `}
`
